import PropTypes from 'prop-types';

export default function FinishIcon(props) {
    const { color, className } = props;

    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="26"
        fill="none"
        viewBox="0 0 25 26"
        className={className}
      >
        <path
          fill={color}
          d="M15.536 8.894v-2.4h-2.429v-2.4H10.68v2.4h2.428v2.4H10.68v2.4h2.428v-2.4h2.429zM17.964 8.894v-2.4h2.429v2.4h-2.429z"
        />
        <path fill={color} d="M17.964 8.894h-2.428v2.4h2.428v-2.4z"/>
        <path
          fill={color}
          fillRule="evenodd"
          d="M6 13.65v7.044a1 1 0 002 0v-6.716a8.06 8.06 0 01.286-.062c.612-.12 1.367-.202 2.285-.202 1.715 0 3.143.572 4.572 1.143C16.57 15.43 18 16 19.714 16c2.712 0 3.994-.715 4.411-1.014a.363.363 0 00.097-.104.416.416 0 00.064-.232V2.35c0-.445-.631-.78-1.046-.618a7.252 7.252 0 01-1.24.351c-.612.12-1.367.203-2.286.203-1.714 0-3.143-.572-4.571-1.143C13.714.57 12.286 0 10.57 0c-2.71 0-3.993.715-4.41 1.014A.405.405 0 006 1.35v12.3zm10.581-9.556a17.076 17.076 0 01-1.045-.346v.346h-2.429V2.807c-.864-.31-1.61-.505-2.428-.52v1.807H8.286v2.4h2.393v2.4H8.286v2.117a.5.5 0 00.087.283h2.306v.135c.872.01 1.682.135 2.428.316v-.451h2.429v1.259l.347.138.109.044c.435.174.832.33 1.207.465.264.095.518.179.765.25v-2.156h2.429v2.402a9.82 9.82 0 00.62-.055c.23-.028.436-.063.617-.1a.448.448 0 00.315-.242.504.504 0 00.055-.228v-1.777h-1.607v-2.4H22v-2.4h-1.607V4.558c-.219.009-.445.013-.679.013a10.53 10.53 0 01-1.75-.153v2.076h-2.428v-2.4h1.045z"
          clipRule="evenodd"
        />
        <path
          fill={color}
          d="M2 21.41c0-.066.047-.309.546-.645.3-.203.704-.395 1.199-.555.525-.17.883-.686.779-1.228-.105-.542-.632-.903-1.161-.747-.736.216-1.399.509-1.938.873C.68 19.612 0 20.384 0 21.41c0 1.357 1.16 2.263 2.272 2.772 1.2.549 2.789.862 4.49.862 1.7 0 3.29-.313 4.49-.862 1.112-.509 2.272-1.415 2.272-2.772 0-.941-.575-1.671-1.236-2.167-.446-.335-.989-.612-1.591-.832-.52-.19-1.064.144-1.197.68-.133.537.2 1.068.711 1.276.362.146.655.31.876.475.4.3.437.507.437.568 0 .097-.13.508-1.104.953-.884.404-2.177.68-3.658.68-1.481 0-2.774-.276-3.659-.68C2.13 21.918 2 21.507 2 21.41z"
        />
      </svg>
    )
}

FinishIcon.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
}